var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "tc-lmc-field",
      class: { "is-expanded": _vm.isExpanded, "is-mobile": _vm.isMobile },
    },
    [
      _c(
        "input",
        _vm._b(
          { ref: "input", staticClass: "is-hidden" },
          "input",
          _vm.inputProperties,
          false
        )
      ),
      _vm._v(" "),
      _c(
        "search-control",
        _vm._g(
          _vm._b(
            {
              attrs: {
                type: _vm.SearchControlType.Primary,
                canFocus: !_vm.isMobile,
              },
              model: {
                value: _vm.searchText,
                callback: function ($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText",
              },
            },
            "search-control",
            _vm.searchControlProps,
            false
          ),
          _vm.searchControlListeners
        )
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "autocomplete-list-fullscreen-fade" } },
        [
          _vm.isExpanded && _vm.isMobile
            ? _c("div", {
                staticClass: "autocomplete-list-fullscreen-background",
                attrs: { "data-no-scroll-lock-offset": "" },
                on: {
                  click: function ($event) {
                    _vm.isExpanded = false
                  },
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "autocomplete-list-fade" } }, [
        _vm.isExpanded
          ? _c(
              "aside",
              { ref: "autoCompleteList", staticClass: "autocomplete-list" },
              [
                _vm.isMobile
                  ? _c(
                      "search-control",
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              isMobile: true,
                              type: _vm.SearchControlType.Modal,
                              closeButton: true,
                            },
                            on: {
                              collapse: function ($event) {
                                _vm.isExpanded = false
                              },
                              keyup: function ($event) {
                                _vm.isSoftLoading = true
                              },
                            },
                            model: {
                              value: _vm.searchText,
                              callback: function ($$v) {
                                _vm.searchText = $$v
                              },
                              expression: "searchText",
                            },
                          },
                          "search-control",
                          _vm.searchControlProps,
                          false
                        ),
                        _vm.searchControlListeners
                      )
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.choices.length == 0
                  ? _c("div", { staticClass: "no-results" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("No results.")) +
                          "\n            "
                      ),
                    ])
                  : _c("div", { staticClass: "results-status" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$format(
                              _vm.$npgettext(
                                "table",
                                "Displaying {count} result of {total} total",
                                "Displaying {count} results of {total} total",
                                _vm.choices.length
                              ),
                              {
                                count: _vm.choices.length,
                                total: _vm.totalResults,
                              }
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.choices.length > 0,
                        expression: "choices.length > 0",
                      },
                    ],
                    ref: "autoCompleteListWrapper",
                    staticClass: "list-wrapper",
                  },
                  _vm._l(_vm.choices, function (choice) {
                    return _c(
                      "div",
                      {
                        key: choice.id,
                        ref: "autoCompleteOptions",
                        refInFor: true,
                        staticClass: "list-option is-unselectable",
                        class: {
                          "is-active":
                            _vm.softSelectedChoice &&
                            _vm.softSelectedChoice.id == choice.id,
                          "is-selected": _vm.value == choice.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.select(choice)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "option-label" }, [
                          _vm._v(_vm._s(choice.label)),
                        ]),
                        _vm._v(" "),
                        _vm.value == choice.id
                          ? _c("bulma-icon", {
                              staticClass: "option-icon",
                              attrs: { name: "fas fa-check" },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }